const isDev = process.env.NODE_ENV !== 'production';

const log = (...args) => {
  if (isDev) console.log('[App]', ...args);
};

const info = (...args) => {
  if (isDev) console.info('[App]', ...args);
};

const warn = (...args) => {
  if (isDev) console.warn('[App]', ...args);
};

const error = (...args) => {
  if (isDev) console.error('[App]', ...args);
};

const logger = { log, info, warn, error };

export default logger;
